<template>
  <el-button class="line-button" v-bind="$attrs" v-on="$listeners">
    <img :class="imgClass" :src="Constants.SHOP_CONFIG.LINE_ICON" alt="" />
    <span>
      <slot />
    </span>
  </el-button>
</template>

<script>
export default {
  name: 'LineButton',
  props: {
    imgClass: {
      type: String,
      default: () => '',
    },
  },
}
</script>

<style lang="scss">
@import '@/assets/css/components/line-button.scss';
</style>
